/** Fixed flake settings so server and client render the same markup. */
const FLAKES = Array.from({ length: 34 }, (_, i) => ({
  left: (i * 29 + 7) % 100,
  size: 2 + (i % 4),
  duration: 7 + ((i * 5) % 9),
  delay: -((i * 1.7) % 12),
  dx: ((i % 5) - 2) * 14,
}));

/**
 * Snow that falls over the taxi picture all the time. It is masked with the picture's own arch shape,
 * so flakes never spill outside it. `src` is the same image the arch shows.
 */
export function HeroSnow({ src }: { src: string }) {
  const mask = `url(${src})`;
  return (
    <div
      className="pointer-events-none absolute inset-0 overflow-hidden"
      style={{ maskImage: mask, WebkitMaskImage: mask, maskSize: '100% 100%', WebkitMaskSize: '100% 100%', maskRepeat: 'no-repeat', WebkitMaskRepeat: 'no-repeat' }}
      aria-hidden
    >
      {FLAKES.map((f, i) => (
        <span
          key={i}
          className="absolute top-0 rounded-full bg-white animate-snow-fall"
          style={{
            left: `${f.left}%`,
            width: f.size,
            height: f.size,
            animationDuration: `${f.duration}s`,
            animationDelay: `${f.delay}s`,
            ['--dx' as string]: `${f.dx}px`,
          }}
        />
      ))}
    </div>
  );
}
